import type { LegacyRef } from 'react';
import React, { forwardRef } from 'react';

import type { SpinnerColorMode, SpinnerSize } from './types';
import * as styles from './LoadingSpinner.styles';

export interface LoadingSpinnerProps {
  className?: string;
  colorMode?: SpinnerColorMode;
  message?: string;
  size?: SpinnerSize;
}

export const LOADING_SPINNER_WRAPPER = 'loading_spinner__wrapper';

/** @deprecated Ribbons consumers should not rely on a Ribbons component's internal implementation details */
export const LOADING_SPINNER_CLASS = 'loading-spinner';

export const LoadingSpinner = forwardRef(
  ({ className, colorMode = 'dark', message, size = 'medium' }: LoadingSpinnerProps, ref) => {
    return (
      <div
        className={className}
        css={styles.loadingWrapper}
        data-testid={LOADING_SPINNER_WRAPPER}
        ref={ref as LegacyRef<HTMLDivElement> | undefined}
      >
        <div css={[styles.spinner, styles.spinnerColor[colorMode], styles.spinnerSize[size]]}></div>
        {message && <p css={styles.loadingMessage}>{message}</p>}
      </div>
    );
  },
);
